
namespace TabAurous.Retail {
    export class SeasonalityOptions {
        items: POSSalesItemsRow[];
    }

    export class SeasonalityPanel extends Serenity.TemplatedPanel<SeasonalityOptions> {
        constructor(container: JQuery, opt: SeasonalityOptions) {
            super(container, opt);


            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0,0,0,0,0,0,0];
            code.pop();
            for (var i = 0; i < data.length; i++) {
                grossamount[0] += data[i].Day1Amount;
                grossamount[1] += data[i].Day2Amount;
                grossamount[2] += data[i].Day3Amount;
                grossamount[3] += data[i].Day4Amount;
                grossamount[4] += data[i].Day5Amount;
                grossamount[5] += data[i].Day6Amount;
                grossamount[6] += data[i].Day7Amount;
            }
            var options = {
                series: [{
                    name: 'Sales',
                    data: grossamount
                }],
                chart: {
                    height: 350,
                    width:760,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                    position: 'top',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "";
                        }
                    }

                },
                title: {
                    text: '',
                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            };     //var x = document.getElementById('TabAurous_Reports_ApprovalInReturnRowPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }


    @Serenity.Decorators.registerClass()
    export class SeasonalityReport extends Serenity.EntityGrid<POSSalesItemsRow, any> {
        protected getColumnsKey() { return 'Retail.Seasonality'; }
        protected getDialogType() { return POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getInsertPermission() { return POSSalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return SeasonalityService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: SeasonalityPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            
        }
     

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            
            return grid;
        }

        onViewProcessData(response: Serenity.ListResponse<POSSalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new SeasonalityPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }

    }
}